module.exports = __webpack_public_path__ + "static/media/Heather.5606f76e.png";